import React, { useEffect, useState } from 'react';
import { Popover, List, Form } from 'antd';
import "./style.css"
import LinkWrapper from '../linkWrapper/page';
const page: any = (props) => {
    const { open, setOpen, recordId, options } = props;

    const getOptions = () => {
        return options?.map((item) => {
            return (<div onClick={(e) => {
                e.stopPropagation()
                e.preventDefault(); // Prevent default action
            }}>
                <List className='new-listitem-popOptions' >
                    {
                        item.redirect ?
                            <LinkWrapper href={item?.path}>
                                <List.Item onClick={() => item.action && item.action()} >
                                    {item.image && <img src={item.image} className='new-popOption-image' alt="Edit" />}
                                    {typeof item.title === "string" ? <p>{item.title}</p> : item.title}
                                </List.Item>
                            </LinkWrapper> :
                            <List.Item onClick={() => item.action && item.action()} >
                                {item.image && <img src={item.image} className='new-popOption-image' alt="Edit" />}
                                {typeof item.title === "string" ? <p>{item.title}</p> : item.title}
                            </List.Item>
                    }

                </List></div>)
        })

    }
    return (
        <Popover
            content={getOptions()}
            open={open}
            onOpenChange={(v) => {
                v ? setOpen(recordId ?? true) : setOpen(undefined)
            }}
            trigger={"click"}
            placement='bottom'
        >
            <div style={{ width: "30px", height: "24px", display: "flex", justifyContent: "center", alignItems: "center", cursor: "pointer" }}
                onClick={(e) => {
                    e.stopPropagation()
                    e.preventDefault(); // Prevent default action
                }}>
                <img style={{ height: 20, width: 5 }} src='/images/dot.png' alt="Options" />
            </div>
        </Popover>
    )
}
export default page;